import { AnalyzeInvoiceSettlementRepository } from './AnalyzeInvoiceSettlementRepository.js'
import AnalyzeInvoiceSettlementMode from './AnalyzeInvoiceSettlementModel'
import { JtechStore } from 'src/plugins/mobx'
import {
  ServiceRequestRepository
} from 'src/modules/concession/service-request/view/financial/invoice/ServiceRequestInvoiceRepository'

export default class AnalyzeInvoiceSettlementController {
  state = AnalyzeInvoiceSettlementMode.getInstance();

  formModalSearch = null
  initialFormModalSearch = null
  static getInstance () {
    return JtechStore.getSingleton('AnalyzeInvoiceSettlementController', new AnalyzeInvoiceSettlementController())
  }

  setSearchParams (searchParams) {
    this.state.setSearchParams(searchParams)
  }

  async loadInvoices () {
    return await AnalyzeInvoiceSettlementRepository.load()
  }

  async loadInvoiceSettlementHistory () {
    return await AnalyzeInvoiceSettlementRepository.loadInvoiceSettlementHistory()
  }

  async loadInvoiceSettlementHistoryDatatable () {
    return await AnalyzeInvoiceSettlementRepository.loadInvoiceSettlementHistoryDatatable()
  }

  async loadInvoiceSettlementHistoryDatatableModel () {
    return await AnalyzeInvoiceSettlementRepository.loadInvoiceSettlementHistoryDatatableModel()
  }

  async loadDatatable () {
    return await AnalyzeInvoiceSettlementRepository.loadDatatable()
  }

  async loadDatatableModel (params) {
    return await AnalyzeInvoiceSettlementRepository.loadDatatableModel(params)
  }

  async loadDetail (params) {
    return await AnalyzeInvoiceSettlementRepository.loadDetail(params)
  }

  async backToMain () {
    return await AnalyzeInvoiceSettlementRepository.backToMain()
  }

  async approve (params) {
    return await AnalyzeInvoiceSettlementRepository.approve(params)
  }

  async deny (params) {
    return await AnalyzeInvoiceSettlementRepository.deny(params)
  }

  async formFilter () {
    if (!this.formModalSearch) {
      this.formModalSearch = await AnalyzeInvoiceSettlementRepository.formFilter()
      this.initialFormModalSearch = this.formModalSearch
    }

    return this.formModalSearch
  }

  async searchWithFilters (params) {
    return await AnalyzeInvoiceSettlementRepository.searchWithFilters(params)
  }

  async loadExemptionMetrics () {
    return await AnalyzeInvoiceSettlementRepository.loadExemptionMetrics()
  }
}
